(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ussa-signup-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('[id^="SignupLanding-"]');
    if (!section) return;

    const btn = section.querySelector('[id^="SignupPrimaryBtn-"]');
    const checkboxes = section.querySelectorAll('.ussa-signup__req-item input[type="checkbox"]');
    if (!btn || checkboxes.length === 0) return;

    function updateBtn() {
      const allChecked = Array.from(checkboxes).every(function (cb) { return cb.checked; });
      if (allChecked) {
        btn.classList.remove('ussa-signup__btn-primary--disabled');
        btn.removeAttribute('disabled');
      } else {
        btn.classList.add('ussa-signup__btn-primary--disabled');
        btn.setAttribute('disabled', '');
      }
    }

    btn.addEventListener('click', function () {
      if (!btn.disabled && btn.dataset.href) {
        window.location.href = btn.dataset.href;
      }
    });

    checkboxes.forEach(function (cb) { cb.addEventListener('change', updateBtn); });
  })();

  } catch(e) { console.error(e); }
})();
})();
